import { CashFlowTransactionType } from '../enums/cash-flow';

export const cashFlowTypeHumanized = {
  [CashFlowTransactionType.RECEIPT]: 'recibo',
  [CashFlowTransactionType.RECHARGE]: 'recarga',
  [CashFlowTransactionType.TRANSPORT]: 'vale-transporte',
  [CashFlowTransactionType.CRAFT]: 'oficio',
  [CashFlowTransactionType.EVENT]: 'evento',
  [CashFlowTransactionType.FIRST_CONTACT]: 'primeiros contatos',
  [CashFlowTransactionType.HAPPY_HOUR]: 'happy hour',
  [CashFlowTransactionType.PARKING]: 'estacionamento',
  [CashFlowTransactionType.PURCHASE_RAW_MATERIAL]: 'matéria-prima',
  [CashFlowTransactionType.SERVICE_PROVISION]: 'prestação de serviço',
  [CashFlowTransactionType.TEST]: 'teste',
  [CashFlowTransactionType.REWARD]: 'premiação',
  [CashFlowTransactionType.SALARY]: 'salário',
  [CashFlowTransactionType.BANK_CHECK]: 'cheque',
  [CashFlowTransactionType.LOAN]: 'empréstimo',
  [CashFlowTransactionType.OTHER]: 'outros',
  [CashFlowTransactionType.BANK_HOUR_PAYMENT]: 'Pagamento de banco de horas',
  [CashFlowTransactionType.CLEANING]: 'limpeza',
};

export const cashFlowTypeColor = {
  [CashFlowTransactionType.RECEIPT]: 'green',
  [CashFlowTransactionType.RECHARGE]: 'blue',
  [CashFlowTransactionType.TRANSPORT]: 'yellow.7',
  [CashFlowTransactionType.OTHER]: 'orange.7',
  [CashFlowTransactionType.CRAFT]: 'violet',
  [CashFlowTransactionType.EVENT]: 'gray',
  [CashFlowTransactionType.FIRST_CONTACT]: 'grape',
  [CashFlowTransactionType.HAPPY_HOUR]: 'grape.6',
  [CashFlowTransactionType.PARKING]: 'orange.3',
  [CashFlowTransactionType.PURCHASE_RAW_MATERIAL]: 'pink.4',
  [CashFlowTransactionType.SERVICE_PROVISION]: 'red.6',
  [CashFlowTransactionType.REWARD]: 'violet.4',
  [CashFlowTransactionType.SALARY]: 'teal',
  [CashFlowTransactionType.BANK_CHECK]: 'gray.6',
  [CashFlowTransactionType.TEST]: 'dark.6',
  [CashFlowTransactionType.LOAN]: 'blue.6',
  [CashFlowTransactionType.BANK_HOUR_PAYMENT]: 'cyan',
  [CashFlowTransactionType.CLEANING]: 'cyan.6',
};

export const cashFlowHistoryHumanized: Record<string, string> = {
  cancelledAt: 'Cancelado',
  createdAt: 'Criado',
  roundedValue: 'Valor arredondado',
  value: 'Valor',
  description: 'Descrição',
  name: 'Responsável/Solicitante',
  type: 'Tipo',
};

export const cashFlowHistoryText: Record<string, string> = {
  cancelledAt: 'cancelou esta movimentação',
  createdAt: 'criou esta movimentação',
};

export const cashFlowTypeList = [
  {
    value: CashFlowTransactionType.RECEIPT,
    label: 'Recibo',
  },
  {
    value: CashFlowTransactionType.BANK_HOUR_PAYMENT,
    label: 'Pagamento de banco de horas',
  },
  {
    value: CashFlowTransactionType.TRANSPORT,
    label: 'Transporte',
  },
  {
    value: CashFlowTransactionType.CRAFT,
    label: 'Oficio',
  },
  {
    value: CashFlowTransactionType.EVENT,
    label: 'Evento',
  },
  {
    value: CashFlowTransactionType.FIRST_CONTACT,
    label: 'Primeiros Contatos',
  },
  {
    value: CashFlowTransactionType.HAPPY_HOUR,
    label: 'Happy Hour',
  },
  {
    value: CashFlowTransactionType.PARKING,
    label: 'Estacionamento',
  },
  {
    value: CashFlowTransactionType.PURCHASE_RAW_MATERIAL,
    label: 'Compra materia-prima',
  },
  {
    value: CashFlowTransactionType.SERVICE_PROVISION,
    label: 'Prestação de serviço',
  },
  {
    value: CashFlowTransactionType.TEST,
    label: 'Teste',
  },
  {
    value: CashFlowTransactionType.REWARD,
    label: 'Premiação',
  },
  {
    value: CashFlowTransactionType.SALARY,
    label: 'Salário',
  },
  {
    value: CashFlowTransactionType.BANK_CHECK,
    label: 'Cheque',
  },
  {
    value: CashFlowTransactionType.LOAN,
    label: 'Empréstimo',
  },
  {
    value: CashFlowTransactionType.OTHER,
    label: 'Outros',
  },
  {
    value: CashFlowTransactionType.CLEANING,
    label: 'Limpeza',
  },
];
